<p-dialog
  [visible]="userProfile.userInvitation?.status === 'sent' && !isSsoUser"
  [modal]="true"
  [appendTo]="'body'"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '480px', maxWidth: '95vw' }"
  styleClass="slm-dialog"
  [attr.data-testid]="'confirm-profile-dialog'"
>
  <ng-template #header>
    <div class="slm-dialog-header">
      <span class="slm-dialog-title">Confirm profile</span>
    </div>
  </ng-template>

  <div class="slm-form-container" [attr.data-testid]="'confirm-profile-wrap'">
    <p class="slm-dialog-description" [attr.data-testid]="'confirm-profile-text'">
      Please confirm your First and Last name to get started.
    </p>

    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" [attr.data-testid]="'confirm-profile-form'">
      <div class="slm-field-group" [attr.data-testid]="'firstName-field'">
        <label for="firstName" class="slm-field-label" [attr.data-testid]="'firstName-label'">
          First name <span class="slm-required">*</span>
        </label>
        <input
          id="firstName"
          pInputText
          type="text"
          formControlName="firstName"
          class="slm-input"
          [attr.data-testid]="'firstName-input'"
        />
        @if (profileForm.controls['firstName'].invalid && profileForm.controls['firstName'].dirty) {
        <div class="slm-field-error" [attr.data-testid]="'firstName-error'">
          @if (profileForm.controls['firstName'].errors?.['required'] ||
          profileForm.controls['firstName'].errors?.['trimWhitespace']) {
          <span [attr.data-testid]="'firstName-error-required'">First name is required.</span>
          } @if (profileForm.controls['firstName'].errors?.['maxlength']) {
          <span [attr.data-testid]="'firstName-error-maxlength'"
            >First name must not be longer than 100 characters.</span
          >
          } @if (profileForm.controls['firstName'].errors?.['invalidHumanName']) {
          <span [attr.data-testid]="'firstName-error-invalid'">First name contains invalid characters.</span>
          }
        </div>
        }
      </div>

      <div class="slm-field-group" [attr.data-testid]="'lastName-field'">
        <label for="lastName" class="slm-field-label" [attr.data-testid]="'lastName-label'">
          Last name <span class="slm-required">*</span>
        </label>
        <input
          id="lastName"
          pInputText
          type="text"
          formControlName="lastName"
          class="slm-input"
          [attr.data-testid]="'lastName-input'"
        />
        @if (profileForm.controls['lastName'].invalid && profileForm.controls['lastName'].dirty) {
        <div class="slm-field-error" [attr.data-testid]="'lastName-error'">
          @if (profileForm.controls['lastName'].errors?.['required'] ||
          profileForm.controls['lastName'].errors?.['trimWhitespace']) {
          <span [attr.data-testid]="'lastName-error-required'">Last name is required.</span>
          } @if (profileForm.controls['lastName'].errors?.['maxlength']) {
          <span [attr.data-testid]="'lastName-error-maxlength'">Last name must not be longer than 100 characters.</span>
          } @if (profileForm.controls['lastName'].errors?.['invalidHumanName']) {
          <span [attr.data-testid]="'lastName-error-invalid'">Last name contains invalid characters.</span>
          }
        </div>
        }
      </div>

      <button type="submit" style="display: none" [disabled]="!profileForm.valid"></button>
    </form>
  </div>

  <ng-template #footer>
    <div class="slm-dialog-footer">
      <p-button
        label="Save and continue"
        [disabled]="!profileForm.valid"
        (onClick)="onSubmit()"
        styleClass="slm-btn slm-btn--primary"
        [attr.data-testid]="'button-login-submit'"
      />
    </div>
  </ng-template>
</p-dialog>
